import React from "react";
import {
  Link, useLocation
} from "react-router-dom";

export default function Navigation() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <a className="navbar-brand text-danger" href="#">
        <img src="/logo.svg" height="45" className="mt-0"/>
      </a>
      {/* <button className="navbar-toggler" type="button">
        <span className="navbar-toggler-icon"></span>
      </button>
      <ul className="collapse navbar-collapse navbar-nav mr-auto">
        
        <li className="nav-item">
          <Link className="nav-link" to="/">Home</Link>
        </li>
       
      </ul> */}
     
    </nav>
  );
}

